import { render, staticRenderFns } from "./Features.vue?vue&type=template&id=3dc3e34d&scoped=true"
import script from "./Features.vue?vue&type=script&lang=js"
export * from "./Features.vue?vue&type=script&lang=js"
import style0 from "./Features.vue?vue&type=style&index=0&id=3dc3e34d&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc3e34d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dc3e34d')) {
      api.createRecord('3dc3e34d', component.options)
    } else {
      api.reload('3dc3e34d', component.options)
    }
    module.hot.accept("./Features.vue?vue&type=template&id=3dc3e34d&scoped=true", function () {
      api.rerender('3dc3e34d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/openAI/components/Features.vue"
export default component.exports